import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { dataSourceStatusActionTypes, dataSourceStatusLoadingAction, dataSourceStatusLoadedAction, } from '../ducks/DataSourceDetailStatus.ducks';
import { getAsyncRequestStatus } from '@ane/core/lib/models';
import DataSourceResource from '../../../DataSource.resource';
const loadDataSourceStatusArgs = {
    filterOnType: dataSourceStatusActionTypes.LOAD,
    loadResource: (payload, state) => {
        return DataSourceResource.getDataSourceStatus(payload.workspaceId, payload.dataSourceName);
    },
    loadingAction: dataSourceStatusLoadingAction,
    loadedAction: (successData, payload, error) => {
        const result = {
            status: getAsyncRequestStatus(error || ''),
            data: successData,
            error: error,
        };
        return of(dataSourceStatusLoadedAction(payload, result));
    },
};
export const loadDataSourceStatusEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadDataSourceStatusArgs);
export default combineEpics(loadDataSourceStatusEpic);

//# sourceMappingURL=DataSourceStatusEpic.js.map
